export * from "./key-codes";
export * from "./urls";
export const GW_ADDITIONAL_INFO_SELECTOR = "#gw-additional-info";
export const GW_ADDITIONAL_INFO_INSTAGRAM_SELECTOR =
    "#gw-additional-info-instagram";
export const CURRENCY_PLACEHOLDER_REGEX = /\{\{\s*(\w+)\s*\}\}/;
export const PRODUCT_VARIANT_DEFAULT_TITLE = "Default Title";

export const WIDGET_VERSION_DATA_ATTR = "gw-widget-version";

export const WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR =
    "gw-widget-shadow-root-enabled";
export const DESIGN_MODE_CUSTOM_CSS_SCRIPT_SELECTOR =
    'script[type="text/custom-css"]';

export enum App {
    /** @internal */
    Login = "social-login",
    Rewards = "rewards",
    Reviews = "reviews",
    Wishlist = "wishlist",
    TikTok = "tiktok",
    Instagram = "instagram",
    Questions = "questions",
    IloomCustomization = "iloom-customization",
    MediaFeed = "media-feed",
    GiftRegistry = "gift-registry",
}

export enum WIDGET_VERSION {
    V1 = "v1",
    V2 = "v2",
}
